/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Status_ResolvedInputs */

const en_claim_status_resolved = /** @type {(inputs: Claim_Status_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolved`)
};

/**
* | output |
* | --- |
* | "Resolved" |
*
* @param {Claim_Status_ResolvedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_status_resolved = /** @type {((inputs?: Claim_Status_ResolvedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Status_ResolvedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_status_resolved(inputs)
});